<template>
	<el-dialog class="dialog" title="新增" :visible.sync="visiable">
		<div v-loading="loading" class="dlalog-body">
			<el-form ref="form" :rules="rules" :model="formData" label-width="180px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="名称：" prop="name"><el-input v-model="formData.name"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="品牌：" prop="brand"><el-input v-model="formData.brand"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="型号：" prop="standard"><el-input v-model="formData.standard" :disabled="dialogObj.type== 2"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="节圆直径：" prop="pitchDiameter"><el-input v-model.number ="formData.pitchDiameter" type="number"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="滚动体直径：" prop="ballDiameter"><el-input v-model.number ="formData.ballDiameter" type="number"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="滚动体数目：" prop="ballsNumber"><el-input v-model.number ="formData.ballsNumber" type="number"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="接触角：" prop="contactAngle"><el-input v-model.number ="formData.contactAngle" type="number"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="转速：" prop="speed"><el-input v-model.number ="formData.speed" type="number"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="内环故障频率：" prop="bpfi"><el-input v-model.number ="formData.bpfi" type="number"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="外环故障频率：" prop="bpfo"><el-input v-model.number ="formData.bpfo" type="number"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="滚动体旋转故障频率：" prop="bsf"><el-input v-model.number ="formData.bsf" type="number"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="保持架故障频率：" prop="ftf"><el-input v-model.number ="formData.ftf" type="number"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注：" prop="remarks"><el-input v-model="formData.remarks"></el-input></el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close()">关闭</el-button>
				<el-button type="primary" @click="submit()">确定</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
var regu = /^[0-9]+\.?[0-9]*$/;
import { dialogMixin } from '@m/dialogMixin';
import configApi from '@config/configApi';
export default {
	mixins: [dialogMixin],
	data() {
		return {
			title: '',
			loading: false,
			formData: {},
			ents: [],
			rules: {
				name: [
					{
						required: true,
						message: '请填写名称',
						trigger: 'change'
					}
				],
				standard: [
					{
						required: true,
						message: '请填写型号',
						trigger: 'change'
					}
				]
			}
		};
	},
	props: {},
	watch: {},
	methods: {
		//打开弹窗
		open() {
			this.formData = {};
			if (this.dialogObj.type == 2) {
				this.get();
			}
			this.$nextTick(() => {
				this.$refs.form.clearValidate();
			});
		},
		get() {
			this.$get('/backend-api/comp/type/bearing/get', {
				id: this.dialogObj.row.id
			}).then(res => {
				if (res.code == 1000) {
					this.formData = res.data;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//提交表单
		submit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true;
					console.log(this.formData.pitchDiameter);
					this.$postData('/backend-api/comp/type/bearing/save', this.formData).then(res => {
						if (res.code == 1000) {
							this.loading = false;
							this.$message.success(res.msg);
							this.$parent.list();
							this.close();
						} else {
							this.loading = false;
							this.$message.error(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		//关闭弹窗
		close() {
			this.visiable = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.dialog {
	::v-deep .cascader {
		display: block;
	}
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
::v-deep input[type='number'] {
	-moz-appearance: textfield;
}
</style>
